// extracted by mini-css-extract-plugin
export default {"root":"Search_root__71egY","icon":"Search_icon__RKKeU","input":"Search_input__wIyZB"};